module.exports = __webpack_public_path__ + "static/images/74ebcb99eb2d8bdeee3de049f20ae60a.webp";